export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center max-w-xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
            Ready to Upgrade Your Workflow?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-light mb-8 max-w-md">
            Discover the full potential of Litbuy Spreadsheet. Visit our main website for the complete product catalog and advanced features.
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            buy it now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>

      {/* Image banner strip at bottom */}
      <div className="mt-12 w-full h-[120px] md:h-[160px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Horizontal%20banner%20composition%20of%20diverse%20lifestyle%20products%20including%20leather%20bag%20watch%20perfume%20bottle%20scarf%20and%20sunglasses%20arranged%20in%20a%20clean%20row%20on%20a%20warm%20cream%20linen%20surface%20soft%20diffused%20overhead%20lighting%20minimalist%20modern%20product%20photography%20with%20consistent%20warm%20neutral%20tones%20and%20gentle%20organic%20shadows&width=2000&height=300&seq=cta-banner-v3-f9n1&orientation=landscape"
          alt="Litbuy Spreadsheet product catalog banner"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
    </section>
  );
}